import { useNavigation as baseUseNavigation } from "@react-navigation/native";

import type { NavScreenProps, RootStackParamList } from "./types";

export function useNavigation<T extends keyof RootStackParamList>() {
  return baseUseNavigation<NavScreenProps<T>["navigation"]>();
}
